<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-title>
  {{ data?.action?.id ? 'Edit Action' : 'Add Action' }}
  <button
    mat-icon-button
    (click)="handleEditComplete(false)"
    title="Cancel"
    class="close-button"
    tabindex="-1"
    >
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (data && data.action) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Action Description</mat-label>
          <input matInput [(ngModel)]="data.action.description" />
        </mat-form-field>
      </div>
    </div>
    @if (data.moveList.length > 0) {
      <div class="add-margin">
        <div>
          <mat-form-field class="button-margins full-width">
            <mat-label>Move {{ data.action.moveNumber }}</mat-label>
            <mat-select placeholder="Move" [value]="data.action.moveNumber.toString()" (selectionChange)="selectMove($event.value)">
              @if (!data.action.id && data.moveList.length > 1) {
                <mat-option value="{{ data.allMovesValue }}">All Moves</mat-option>
              }
              @for (move of data.moveList; track move) {
                <mat-option [value]="move.moveNumber.toString()">
                  {{ move.moveNumber }} - {{ move.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    @if (data.teamList.length > 0) {
      <div class="add-margin">
        <div>
          <mat-form-field class="button-margins full-width">
            <mat-label>Team</mat-label>
            <mat-select placeholder="Team" [(ngModel)]="data.action.teamId">
              @if (!data.action.id && data.teamList.length > 1) {
                <mat-option value="">All Teams</mat-option>
              }
              @for (team of data.teamList; track team) {
                <mat-option [value]="team.id">
                  {{ team.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    <div class="cssLayoutRowStartCenter bottom-button">
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()" style="margin-left: 40px;">Save</button>
      </div>
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
      </div>
    </div>
  </div>
}
